// extracted by mini-css-extract-plugin
export default {"paymentSection":"q--z"};